import { makeAutoObservable } from 'mobx';
import {DomainStore} from 'shared/store';

class MyExpensesState {
  store = new DomainStore();
  history;

  constructor() {
    makeAutoObservable(this, {
      store: false,
      history: false
    });
  }

  receiveProps({history}) {
    this.history = history;
  }

  goToNewExpense() {
    this.history.push('/expense_requests/new');
  }

  async removeExpenseRequest(request) {
    return this.store.destroy(request);
  }
}

export default MyExpensesState;
